<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-06 20:03:29
-->
<template>
	<div class="mt-12 yx-form-wrap mb-12" style="border: none">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="店铺名称">
				<el-input v-model="formData['name']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="店铺ID">
				<el-input v-model="formData['outerShopId']" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item label="协作状态">
				<el-select v-model="formData['collaborativeStatus']" clearable placeholder="请选择协作状态">
					<el-option :label="item.label" :value="item.value" v-for="(item, index) in satusList" :key="index"></el-option>
				</el-select>
			</el-form-item>

			<el-form-item :label="zsRoleName" v-if="hasDeptDataScope">
				<zs-partner-select v-model="formData['userId']"></zs-partner-select>
			</el-form-item>
			<el-form-item label="部门" v-if="showDeptSelect && isAllDataView">
				<deptTreeSelect returnArray v-model="formData['deptIds']" :collapseTags="true" size="small" ref="deptTreeSelect" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import { zsRoleType } from '@/utils/dataMap';
import zsPartnerSelect from '@/components/zsPartnerSelect';
import { mapGetters } from 'vuex';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
export default {
	name: 'search',
	props: {
		partnerArr: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		deptTreeSelect,
		zsPartnerSelect,
	},
	data() {
		return {
			formData: {
				name: '',
				outerShopId: '',
				collaborativeStatus: '',
				deptIds: [],
				userId: '',
			},
			satusList: [
				{
					label: '全部',
					value: '-1',
				},
				{
					label: '未绑定',
					value: '0',
				},
				{
					label: '已绑定',
					value: '1',
				},
			],
			createArr: [],
		};
	},
	computed: {
		...mapGetters(['showDeptSelect', 'isAllDataView', 'hasDeptDataScope']),
		zsRoleName() {
			return zsRoleType.name;
		},
	},
	methods: {
		onClear() {
			this.formData = {
				name: '',
				outerShopId: '',
				collaborativeStatus: '',
				deptIds: [],
				userId: '',
			};
			this.onSubmit();
		},
		onSubmit: throttle(function() {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
